import Model from "~/models/_Model";

export default class Assessment extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/mtss";
  }

  // Set the resource route of the model
  resource() {
    return "assessments";
  }

  relations() {
    return {};
  }

  primaryKey() {
    return "code";
  }

  /**
   * Helper Methods
   */

  /**
   * Helper Attributes
   */
}
